export default __webpack_public_path__ + "static/media/operator-tablet.43f1978f.svg";